import { Markdown } from "@/components/CodeGen";
import { TextFileSkeleton } from "./TextFileSkeleton";

interface MarkdownFileViewProps {
  file: {
    content: string;
    status: "processing" | "completed";
  };
}

const syntaxHighlighterOptions = {
  className: "rounded-md px-0 py-4 bg-muted",
  showLineNumbers: false,
};

export function MarkdownFileView({ file }: MarkdownFileViewProps) {
  const isFileStreaming = file.status === "processing";
  const shouldShowSkeleton = isFileStreaming && !file.content;

  if (shouldShowSkeleton) {
    return (
      <div className="px-6 overflow-hidden">
        <TextFileSkeleton />
      </div>
    );
  }

  return (
    <div className="px-6">
      <Markdown
        syntaxHighlighterOptions={syntaxHighlighterOptions}
        isStreaming={isFileStreaming}
        SkeletonComponent={TextFileSkeleton}
        withTableOfContents
      >
        {file.content ?? ""}
      </Markdown>
    </div>
  );
}
